import Location from './location_routes';
import Status from './status_routes';
import DeliveryMethod from './delivery-method';
import PaymentMethod from './payment-method';
import Config from './configuration';

const SettingsRoutes = [
  ...Location,
  ...Status,
  ...DeliveryMethod,
  ...PaymentMethod,
  ...Config,
];

export default SettingsRoutes;
